<div class="page fill-dashboard">
  <div class="page-header">
    <div>
      <h1>{{ 'DASHBOARD.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'DASHBOARD.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <label class="week-picker">
        <span>{{ 'PLAN.WEEK' | translate }}</span>
        <select [(ngModel)]="weekOrdinal" (ngModelChange)="onWeekChange()">
          <option *ngFor="let week of weekOptions" [ngValue]="week.ordinal">{{ week.name }}</option>
        </select>
      </label>
      <button type="button" class="btn btn-secondary" (click)="loadReport()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        {{ 'DASHBOARD.REFRESH' | translate }}
      </button>
    </div>
  </div>

  <div class="alert alert-error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

  <div class="card detail-card" *ngIf="loading && !report">
    <div class="empty-state">{{ 'COMMON.LOADING' | translate }}</div>
  </div>

  <ng-container *ngIf="report">
    <section class="summary-grid">
      <button type="button" class="summary-card" [class.active]="statusFilter === 'all'" (click)="setFilter('all')">
        <span class="summary-label">{{ 'DASHBOARD.TOTAL' | translate }}</span>
        <strong>{{ report.summary.total }}</strong>
      </button>
      <button type="button" class="summary-card filled" [class.active]="statusFilter === 'filled'" (click)="setFilter('filled')">
        <span class="summary-label">{{ 'DASHBOARD.STATUS_FILLED' | translate }}</span>
        <strong>{{ report.summary.filled }}</strong>
      </button>
      <button type="button" class="summary-card incomplete" [class.active]="statusFilter === 'incomplete'" (click)="setFilter('incomplete')">
        <span class="summary-label">{{ 'DASHBOARD.STATUS_INCOMPLETE' | translate }}</span>
        <strong>{{ report.summary.incomplete }}</strong>
      </button>
      <button type="button" class="summary-card not-started" [class.active]="statusFilter === 'not_started'" (click)="setFilter('not_started')">
        <span class="summary-label">{{ 'DASHBOARD.STATUS_NOT_STARTED' | translate }}</span>
        <strong>{{ report.summary.not_started }}</strong>
      </button>
      <button type="button" class="summary-card suspicious" [class.active]="statusFilter === 'suspicious'" (click)="setFilter('suspicious')">
        <span class="summary-label">{{ 'DASHBOARD.STATUS_SUSPICIOUS' | translate }}</span>
        <strong>{{ report.summary.suspicious }}</strong>
      </button>
    </section>

    <p class="hint">{{ 'DASHBOARD.SUSPICIOUS_HINT' | translate }}</p>

    <div class="card table-card">
      <div class="table-toolbar">
        <div class="table-toolbar-left">
          <input
            type="search"
            class="search-input"
            [(ngModel)]="search"
            [placeholder]="'DASHBOARD.SEARCH' | translate"
          />
        </div>
        <div class="table-toolbar-right">
          <span class="muted">{{ filteredRows.length }} / {{ report.summary.total }}</span>
        </div>
      </div>

      <div class="table-scroll">
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ 'DASHBOARD.TEACHER' | translate }}</th>
              <th>{{ 'PLAN.CLASS' | translate }}</th>
              <th>{{ 'DASHBOARD.SUBJECT' | translate }}</th>
              <th>{{ 'DASHBOARD.STATUS' | translate }}</th>
              <th>{{ 'DASHBOARD.FILL' | translate }}</th>
              <th>{{ 'DASHBOARD.CELLS' | translate }}</th>
              <th class="actions-col">{{ 'COMMON.ACTIONS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of filteredRows" [class]="'row-' + row.status">
              <td>
                <div class="teacher-cell">
                  <strong>{{ row.teacherName || ('COMMON.NOT_ASSIGNED' | translate) }}</strong>
                </div>
              </td>
              <td>{{ row.className }}</td>
              <td>{{ row.subjectName }}</td>
              <td>
                <span class="status-badge" [attr.data-status]="row.status">
                  {{ statusLabelKey(row.status) | translate }}
                </span>
              </td>
              <td>
                <div class="fill-bar" [attr.title]="row.fillPercent + '%'">
                  <span [style.width.%]="row.fillPercent"></span>
                </div>
                <span class="muted">{{ row.fillPercent }}%</span>
              </td>
              <td class="cells-meta">
                <span>{{ row.meaningfulCells }}/{{ row.expectedCells }}</span>
                <span class="muted" *ngIf="row.fillerCells"> · {{ 'DASHBOARD.FILLER' | translate }}: {{ row.fillerCells }}</span>
              </td>
              <td class="actions-col">
                <button
                  type="button"
                  class="btn btn-secondary btn-sm review-btn"
                  (click)="openPlan(row)"
                  [title]="'DASHBOARD.OPEN_PLAN' | translate"
                >
                  <mat-icon>open_in_new</mat-icon>
                  {{ 'DASHBOARD.OPEN_PLAN' | translate }}
                </button>
              </td>
            </tr>
            <tr *ngIf="!filteredRows.length">
              <td colspan="7" class="empty-row">{{ 'DASHBOARD.EMPTY' | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>
